import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const A = '#00D4AA';

export function NotifBel({ style }) {
  const navigate = useNavigate();
  const [n, setN] = useState(0);
  useEffect(() => {
    let actief = true;
    const laad = async () => {
      try { const r = await api.get('/klantportaal/notificaties'); if (actief) setN(r.data.ongelezen || 0); } catch (e) {}
    };
    laad();
    const iv = setInterval(laad, 60000);
    return () => { actief = false; clearInterval(iv); };
  }, []);
  return (
    <button onClick={() => navigate('/notificaties')} aria-label="Meldingen" style={{ position: 'relative', background: 'transparent', border: '1px solid #1f2937', color: '#e2e8f0', width: 40, height: 40, borderRadius: 10, cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', ...style }}>
      <span>&#128276;</span>
      {n > 0 && <span style={{ position: 'absolute', top: -6, right: -6, background: '#ef4444', color: '#fff', borderRadius: 999, minWidth: 18, height: 18, fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 4px' }}>{n > 9 ? '9+' : n}</span>}
    </button>
  );
}

export default function PortalLayout({ titel, children }) {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#f1f5f9' }}>
      <header style={{ background: '#0a0e1a', color: '#e2e8f0', padding: '14px 20px', paddingTop: 'calc(env(safe-area-inset-top, 0px) + 14px)', display: 'flex', alignItems: 'center', gap: 12, position: 'sticky', top: 0, zIndex: 10 }}>
        <button onClick={() => navigate('/')} style={{ background: 'transparent', border: '1px solid #1f2937', color: '#94a3b8', padding: '6px 12px', borderRadius: 8, fontSize: 14, cursor: 'pointer' }}>&larr; Terug</button>
        <div style={{ fontSize: 16, fontWeight: 700 }}>{titel}</div>
        <NotifBel style={{ marginLeft: 'auto' }} />
      </header>
      <main style={{ padding: 20, maxWidth: 720, margin: '0 auto' }}>{children}</main>
    </div>
  );
}

export const card = { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 14, marginBottom: 10 };
export function SearchBar({ value, onChange, placeholder }) {
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || 'Zoeken...'}
      style={{ width: '100%', boxSizing: 'border-box', padding: '11px 14px', border: '1px solid #e2e8f0', borderRadius: 10, fontSize: 14, marginBottom: 12, outline: 'none', background: '#fff', color: '#1e293b' }}
    />
  );
}
export function matchZoek(q, ...velden) {
  if (!q) return true;
  const t = q.toLowerCase();
  return velden.some((v) => (v == null ? '' : String(v)).toLowerCase().includes(t));
}

export function StateMsg({ loading, error, leeg, leegTekst }) {
  if (error) return <p style={{ color: '#dc2626', textAlign: 'center', marginTop: 30 }}>{error}</p>;
  if (loading) return <p style={{ color: '#64748b', textAlign: 'center', marginTop: 30 }}>Laden&#8230;</p>;
  if (leeg) return <p style={{ color: '#64748b', textAlign: 'center', marginTop: 40 }}>{leegTekst}</p>;
  return null;
}

export function datumNL(d) {
  if (!d) return '\u2014';
  try { return new Date(d).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return '\u2014'; }
}
export function datumTijdNL(d) {
  if (!d) return '\u2014';
  try { return new Date(d).toLocaleString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }); } catch (e) { return '\u2014'; }
}
